define([
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/listbuilder/popup',
], (ListBuilderPopup) => {

  class ClickTrigger extends ListBuilderPopup {
    constructor(service, settings) {
      super(service, settings);
    }

    getAutoRedirectSubscribed() {
      return (this.settings.get('auto_redirect_subscribed') === true);
    }

    getHasRedirect() {
      const url = this.settings.get('subscribe_redirect_url');

      return (url && url.length > 0);
    }

    getSubscribeRedirectUrl() {
      if (!this.getHasRedirect()) return false;

      return this.settings.get('subscribe_redirect_url');
    }

    onClick(el) {
      const isSubscribed = this.service.getSubscribedCookie();
      const autoRedirectSubscribed = this.getAutoRedirectSubscribed();
      const isUpgrade = ((el.getAttribute('data-content-upgrade') == true || autoRedirectSubscribed) && el.getAttribute('data-content-upgrade') != false) ? true : false;
      const hasRedirect = this.getHasRedirect();

      if (isSubscribed && isUpgrade && hasRedirect) {
        const contentUpgradeURL = this.getSubscribeRedirectUrl();

        setTimeout(() => window.location = contentUpgradeURL, 250);
      } else {
        this.service.onShow(this);
      }
    }
  }

  return ClickTrigger;
});
